import React, { useEffect, useState } from "react";
import { Button, ConfigProvider, Skeleton, Tag } from "antd";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { APIConstants } from "../../../../../../Common/APIConstants";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
// import TreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { calculateDateRangeFromDate } from "../../../../../../Utils/DateConverstion";
import {
  CheckCircleFilled,
  CloseCircleFilled, 
  ClockCircleFilled, 
  FilterOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import Empty from "../../../../../CommonScreens/Empty";
import NotAuthenticated from "../../../../../CommonScreens/NotAuthenicated";
import SteamTreeSelectCustomWithSelectAll from "../LiveTrends/LineChart/TreeSelectCustomWithAllSelect";

const ParameterView = () => {
  const { makeRequest,screenNameChecker } = useStoreUpdaterWithAPI();

  const [open, setOpen] = useState(false);
  const [sectionId, setSectionId] = useState(1);
  const [converterGroupId, setConverterGroupId] = useState(1);
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [defaultLoad,setDefaultLoad]=  useState(true)

  const [MeterData, setMeterData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [flowSectionList, setFlowSectionList] = useState([]);
  const [flowConverterList, setFlowConverterList] = useState([]);
  const [flowGroupDetailList, setFlowGroupDetailList] = useState([]);
  const [nsFlowConverterList, setNsFlowConverterList] = useState([]);
  const [GroupMeterList, setGroupMeterList] = useState([]);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [input, setInput] = useState(null);
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
  const [latestDate, setLatestDate] = useState(null);
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };
function getLatestDate(data) {
  if (!Array.isArray(data) || data.length === 0) return null;

  // Filter out invalid or placeholder dates
  const validData = data.filter(item => {
    const d = new Date(item.createdOn);
    return d instanceof Date && !isNaN(d) && item.createdOn !== "0001-01-01T00:00:00";
  });

  if (validData.length === 0) return null;

  return validData.reduce((latest, current) => {
    const currentDate = new Date(current.createdOn);
    const latestDate = new Date(latest.createdOn);
    return currentDate > latestDate ? current : latest;
  });
}

  const fetchMeterLive = () => { 
    setIsLoading(true) 
    const input = JSON.parse(localStorage.getItem("inputData"));
    //console.log(input)
    // //console.log("URL :", url);
    if(input&&input.SectionID&&input.ConverterorGroupID&&input.MeterIds&&input.FromDate&&input.ToDate&&!open){
      const url = `${APIConstants.ELECTRICAL_PARAMETER_VIEW}?SectionID=${input.SectionID}&ConverterorGroupID=${input.ConverterorGroupID}&MeterIds=${input.MeterIds}&FromDate=${input.FromDate}&Todate=${input.ToDate}`;
      makeRequest({ type: APIConstants.GET, url: url })
        .then((res) => {
          //console.log("Meter Data Response:", res);
          if(res&&res.length>0){
             const date = getLatestDate(res);
             //console.log(date)
        //console.log("Latest Date:", date.createdOn.replace("T", " "));
        setLatestDate(date?.createdOn?.replace("T", " "));
            setMeterData(res);
          }
          setTimeout(() => {
            setIsLoading(false);
          }, 2000);
        })
        .catch((error) => {
          setIsLoading(false);
          //console.error("Error fetching meter data:", error);
        });
    }
  };

  // //console.log("Loading :", isLoading);

  useEffect(() => {
    if (input) {
      fetchMeterLive(input);
    }
  }, [input]);

  const fetchNsFlow = (id) => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_COVERTER_DETAILS}?ConverterID=${id}`,
    }).then((res) => {
      // //console.log("Converter Details :", res);
      if(res&&res.length>0){
          if(defaultLoad){
          setSelectedMeterIds(res.map(meter => meter.meterid))
          localStorage.setItem("ParaMeterIds", res.map(meter => meter.meterid));
          setDefaultLoad(false)
        }
        setNsFlowConverterList(res);
      }
    });
  };

  useEffect(() => {
    if (converterGroupId&&sectionId==1) {
      fetchNsFlow(converterGroupId);
    }
  }, [converterGroupId]);

  const fetchGroupMeter = (id) => {
    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${id}&Module=1`,
    }).then((res) => {
      // //console.log("Meter details :", res);
      if(res&&res.length>0){
        setGroupMeterList(res); 
      }
    });
  };

  useEffect(() => {
    if (converterGroupId&&sectionId==2) {
      fetchGroupMeter(converterGroupId);
    }
  }, [converterGroupId]);

  // useEffect(() => {
  //   makeRequest({
  //     type: APIConstants.POST,
  //     // GetFlowSteamGropeMeterDetails?GroupID=81
  //     url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`,
  //   }).then((res) => {
  //     // //console.log(res);
  //     if(res&&res.length>0){
  //       setFlowGroupDetailList(res);
  //     }
  //   });
  // }, []);


  const fetchFlowSectionList = async () => {
  try {
    const sections = await makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_FLOW_SECTION_MASTER_DETAILS,
    });
    setFlowSectionList(sections);
  } catch (error) {
    //console.error("Error fetching Flow Section details:", error);
  } finally {
    setIsLoading(false); // Optional: Only if you want to stop loading after this
  }
};

const fetchConverterList = async () => {
  try {
    const converters = await makeRequest({
      type: APIConstants.GET,
      url: APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS,
    });
    setFlowConverterList(converters);
  } catch (error) {
    //console.error("Error fetching Converter details:", error);
  } finally {
    setIsLoading(false);
  }
};
useEffect(() => {
  setIsLoading(true);

  fetchFlowSectionList();

}, []);
useEffect(() => {
  if(sectionId==1){
    fetchConverterList();
  }
  if(sectionId==2){
    fetchSteamGroupList();

}
}, [sectionId]);

const fetchSteamGroupList = async () => {
  try {
    const groups = await makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`,
    });
    setFlowGroupDetailList(groups);
  } catch (error) {
    //console.error("Error fetching Steam Group details:", error);
  } finally {
    setIsLoading(false);
  }
};


  // useEffect(() => {
  //   setIsLoading(true);

  //   Promise.all([
  //     makeRequest({
  //       type: APIConstants.GET,
  //       url: APIConstants.GET_FLOW_SECTION_MASTER_DETAILS,
  //     }),
  //     makeRequest({
  //       type: APIConstants.GET,
  //       url: APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS,
  //     }),
  //     makeRequest({
  //       type: APIConstants.GET,
  //       url: APIConstants.GET_STEAM_FLOW_GROUP_DETAILS,
  //     }),
  //   ])
  //     .then(([sections, converters, groups]) => {
  //       // //console.log("Sections:", sections);
  //       // //console.log("Converters:", converters);
  //       // //console.log("Groups:", groups);

  //       setFlowSectionList(sections);
  //       setFlowConverterList(converters);
  //       // setFlowGroupDetailList(groups);
  //     })
  //     .catch((error) => {
  //       //console.error("Error fetching initial data:", error);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // }, []);

    useEffect(() => {
   localStorage.setItem("ParaSectionId", 1);
       localStorage.setItem("ParaConverterGroupId", 1);
       return () => {
         console.log("Component unmounted — clearing localStorage");
         localStorage.removeItem("ParaSectionId");
             localStorage.removeItem("ParaConverterGroupId");
             localStorage.removeItem("ParaMeterIds");
     
    };

    }, []);
  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    localStorage.setItem('ParaSectionId',changedValues)
    localStorage.setItem("ParaMeterIds", '');
    localStorage.setItem("ParaConverterGroupId", '');
    setSelectedMeterIds([]);
    setConverterGroupId(null);
    setSubmitClicked(false);
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    localStorage.setItem('ParaConverterGroupId',changedValues)
    setSubmitClicked(false);
    setSelectedMeterIds([]);
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    localStorage.setItem('ParaMeterIds',selectedValues)
    if (!selectedValues.length) {
      setSubmitClicked(false);
    }
  };

    useEffect(() => {
    const interval = setInterval(() => {
      // //console.log("1 minute passed");
      setInputData()
    }, 60000); // 60000 ms = 1 minute
  
    return () => clearInterval(interval); // cleanup on unmount
  }, []);
    useEffect(() => {
   setInputData()
  }, [defaultLoad]);

  const setInputData = () => {
    const ids = selectedMeterIds?.join(",");

    const currentDate = new Date();
    // //console.log(currentDate);
    const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
    // //console.log("From Date :", from);
    // //console.log("To Date :", to);
    // //console.log("CURRENT DATE :", currentDate);
    // const from="11-13-2024"
    // const to="11-13-2024"
    const encodedMeterIds = encodeURIComponent(ids);

    const section =localStorage.getItem('ParaSectionId')
    const converterGroup =localStorage.getItem('ParaConverterGroupId')
    const meterids =localStorage.getItem('ParaMeterIds')
    //console.log(meterids,section,converterGroup)

    const inputData = {
      SectionID: Number(section)||1,
      ConverterorGroupID: Number(converterGroup)||1,
      MeterIds: encodedMeterIds|| meterids,
      FromDate: from,
      ToDate: to,
    };
    //console.log(inputData)
    localStorage.setItem("inputData", JSON.stringify(inputData));
    setInput(inputData);
  };

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter/Group");
    const meterError = validateInput(selectedMeterIds.length > 0, "Meter");

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);

    if (!sectionError && !converterError && !meterError) {
      setInputData();
      onClose();
    } else {
      setSubmitClicked(true);
    }
  };

  const columnDefs = [
    {
      headerName: "STATUS",
      field: "status",
      headerStyle: { fontWeight: "800" },
      width: 90,
      pinned: "left",
      cellRenderer: (params) => {
        let icon;
        if (params.data.meterStatus === "ON") {
          icon = (
            <CheckCircleFilled style={{ fontSize: "20px", color: "green" }} />
          );
        } else if (params.data.meterStatus === "OFF") {
          icon = (
            <CloseCircleFilled style={{ fontSize: "20px", color: "red" }} />
          );
        } else if (params.data.meterStatus === "idle") {
          icon = (
            <ClockCircleFilled style={{ fontSize: "20px", color: "yellow" }} />
          );
        }
        //   else {
        //   icon = <ClockCircleFilled style={{ fontSize: '20px', color: 'yellow' }} />;
        // }

        return (
          <div
            style={{
              margin: "5px",
              marginLeft: "10px",
              border: "none",
              outline: "none",
            }}
          >
            {icon}
          </div>
        );
      },
    },
    {
      headerName: "SITE NAME",
      field: "siteName",
      headerStyle: { fontWeight: "800" },
      width: 170,
      pinned: "left",
    },
    {
      headerName: "METER NAME",
      field: "metername",
      headerStyle: { fontWeight: "800" },
      width: 170,
      pinned: "left",
    },
    {
      headerName: "METER ID",
      field: "meterId",
      headerStyle: { fontWeight: "800" },
      width: 100,
      pinned: "left",
    },
    {
      headerName: "VR",
      field: "vr",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "VY",
      field: "vy",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "VB",
      field: "vb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "F",
      field: "f",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "VRY",
      field: "vry",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "VYB",
      field: "vyb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "VBR",
      field: "vbr",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "VLLAvg",
      field: "vllAvg",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "IR",
      field: "ir",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "IY",
      field: "iy",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "IB",
      field: "ib",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "IAVG",
      field: "iavg",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "Vunb",
      field: "vunb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "lunb",
      field: "iunb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KWT",
      field: "kwt",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVAT",
      field: "kvat",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVART",
      field: "kvart",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "PFT",
      field: "pft",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "PFR",
      field: "pfr",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "PFY",
      field: "pfy",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "PFB",
      field: "pfb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KWR",
      field: "kwr",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KWY",
      field: "kwy",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KWB",
      field: "kwb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVAR",
      field: "kvaR_R",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVAY",
      field: "kvA_Y",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVAB",
      field: "kvaR_B",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVARR",
      field: "kvarr",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVARY",
      field: "kvaR_Y",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVARB",
      field: "kvarb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KWD",
      field: "kwd",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVAD",
      field: "kvad",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KWHTotal",
      field: "kwhTotal",
      headerStyle: { fontWeight: "800" },
      width: 130,
    },
    {
      headerName: "KWHImport",
      field: "kWhImport",
      headerStyle: { fontWeight: "800" },
      width: 130,
    },
    {
      headerName: "KWHExport",
      field: "kwhexport",
      headerStyle: { fontWeight: "800" },
      width: 130,
    },
    {
      headerName: "KVAH",
      field: "kVAh",
      headerStyle: { fontWeight: "800" },
      width: 130,
    },
    {
      headerName: "KVARHTotal",
      field: "kVArhTotal",
      headerStyle: { fontWeight: "800" },
      width: 130,
    },
    {
      headerName: "KVARHInductive",
      field: "kVArInductive",
      headerStyle: { fontWeight: "800" },
      width: 160,
    },
    {
      headerName: "KVARHCapacitive",
      field: "kvarH_CAPACITIVE",
      headerStyle: { fontWeight: "800" },
      width: 160,
    },
    {
      headerName: "CREATED ON",
      field: "createdOn",
      headerStyle: { fontWeight: "800" },
      width: 130,
    },
    {
      headerName: "V THD AVG",
      field: "v_THDAvg",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "V THD R",
      field: "v_THDR",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "V THD Y",
      field: "v_THDY",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "V THD B",
      field: "v_THDB",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "I THD AVG",
      field: "i_THDAvg",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "I THD R",
      field: "i_THDR",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "I THD Y",
      field: "i_THDY",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "I THD B",
      field: "i_THDB",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
  ];

  // //console.log(MeterData);
   const color = useSelector((state) => state.ThemeChange);
    // //console.log(color)

  return (
    <div className="w-full p-4">
      {/* <div className="flex justify-between items-center px-2 pb-0">
        <div className="text-3xl">
        <h4 className={`text-left text-[30px] mb-5 dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>
            PARAMETER VIEW
        </h4> 
        </div>
        <div className="flex gap-5">
          <div className={` ${isdarkMode? "text-white bg-slate-400":'text-black bg-slate-100'} border rounded-lg p-2 px-4 flex items-center justify-center mr-2 font-semibold`} >
              Last Poll Date : 
              {latestDate}
            </div>
              <Tag className="animated-tag w-24 text-lg">
                        <EnvironmentOutlined className="mr-1" />
                        Live
                      </Tag>
          <Button
            role="primary"
            size="large"
            className="flex justify-center items-center secondary-btn"
            style={{ "--secondary-color": color.themeConfig.secondaryColor,"--primary-color": color.themeConfig.colorPrimary }}
            onClick={() => setOpen(!open)}
          >
            <FilterOutlined /> Filter
          </Button>
        </div>
      </div> */}
 <div className="sm:flex-col justify-between items-center md:flex md:flex-row">
          <div className="text-xl md:text-3xl w-full md:w-fit flex">
          <p className={` pb-0 text-center font-[500]  ml-3 tracking-[1px] dark ${isdarkMode ? 'darkfont' : 'whitemode'} `}>PARAMETER VIEW</p>
          </div> 
          <div className="md:flex flex-col px-4 md:p-0 gap-2 md:flex-row ">
            <div className={` ${isdarkMode? "text-white bg-slate-400":'text-black bg-slate-100'} border rounded-lg p-2 px-4 flex items-center justify-center mr-2 font-semibold`} >
              Last Poll Date : 
              {latestDate}
            </div>
            <div className="flex justify-evenly mt-2 md:mt-0">
              <Tag className="animated-tag w-24 text-lg">
                        <EnvironmentOutlined className="mr-1" />
                        Live
                      </Tag>
         <Button role="primary" size="large" 
          className="flex justify-center items-center secondary-btn"
          style={{ "--secondary-color": color.themeConfig.secondaryColor,"--primary-color": color.themeConfig.colorPrimary }}
           onClick={()=>setOpen(!open)}>
         <FilterOutlined /> Filter
         </Button>

            </div>
          </div>
      </div>
      { MeterData && MeterData.length>0 ? (
         
        <div
          className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
          style={{
            '--ag-header-background-color': color.themeConfig.colorPrimary, 
            '--ag-header-foreground-color': '#fff', 
            height: "80vh", width: "100%", overflowY: "auto" 
          }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowData={MeterData}
            pagination={true}
            domLayout="normal"
            defaultColDef={{  
              resizable: true,
            }}
            rowHeight={50}
            suppressHorizontalScroll={false}
          />
        </div>
      ) : (
        <div className={`${!isdarkMode ? "text-black " : "text-white "} text-center`}
        >
          <Empty open={open}  setOpen={setOpen} isdarkMode={isdarkMode} />
        </div>
      )}

      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
        className={`dark ${isdarkMode ? "darkmode" : "whitemode"}`}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={flowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
            selectedValues={sectionId}
          />
          {sectionError && (
            <small className="font-bold ml-[150px] text-red-500">
              {sectionError}
            </small>
          )}
          <CustomSelect
            label="Converter / Group:"
            options={sectionId === 1 ? flowConverterList : flowGroupDetailList}
            onSelect={handleChangeConverterGroup}
            // valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            // nameKey={sectionId === 1 ? "sitename" : "department"}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
            selectedValues={converterGroupId}
          />
          {converterError && (
            <small className="text-red-500 font-bold ml-[150px]">
              {converterError}
            </small>
          )}
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={sectionId === 1 ? nsFlowConverterList : GroupMeterList}
            idKey={sectionId === 1 ? "meterid" : "meterid"}
            valueKey={sectionId === 1 ? "meterid" : "meterid"}
            nameKey={sectionId === 1 ? "metername" : "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          {meterError && (
            <small className="text-red-500 font-bold ml-[150px]">
              {meterError}
            </small>
          )}
        </div>
        <div className="flex justify-center mt-4">
                     <Button
                       type= {isdarkMode? "":'primary'}
                       onClick={() => {
                         handleSubmit();
                       }}
                     >
                       Search
                     </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default ParameterView;
